import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { NavbarSmallLinks } from "helpers/constants";
import { userActions } from "store-redux/user-slice";
import { modalActions } from "store-redux/modal-slice";

import Backdrop from "components/UI/modal/Backdrop";
import NavbarItem from "../navbar-list/navbar-item/NavbarItem";
import classes from "./NavbarListIcon.module.css";

const getInitials = (name = "") => {
  const initials = name
    .trim()
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("");

  return initials || "SA";
};

const NavbarListIcon = ({ className, setSigninModalHandler }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isListModalVisable, setIsListModalVisable] = useState(false);

  const { user, isLoggedIn } = useSelector((state) => state.user);
  const profile = user?.user || {};

  const closeMenu = () => setIsListModalVisable(false);

  const setIsListModalVisableHandler = () => {
    setIsListModalVisable((prevIsListModalVisable) => !prevIsListModalVisable);
  };

  const onClickSignoutHandler = () => {
    dispatch(userActions.logout());
    navigate("/");
  };

  const showSignin = () => {
    if (setSigninModalHandler) {
      setSigninModalHandler();
      return;
    }

    dispatch(
      modalActions.changeModalComponent({
        modalType: "signin",
      })
    );
  };

  // Watchlist is hidden for now.
  // const onWatchlistClick = () => {
  //   if (!isLoggedIn) {
  //     showSignin();
  //     return;
  //   }
  //
  //   navigate("/dashboard/watchlist/inventory");
  // };

  const transactionHandle = () => {
    if (isLoggedIn) {
      navigate("dashboard/transactions?page=1&limit=5");
      closeMenu();
      return;
    }

    showSignin();
  };

  const winsHandle = () => {
    if (isLoggedIn) {
      navigate("dashboard/wins?page=1&limit=10");
      closeMenu();
      return;
    }

    showSignin();
  };

  const depositHandle = () => {
    closeMenu();
    dispatch(
      modalActions.changeModalComponent({
        modalType: "securityDeposit",
      })
    );
  };

  return (
    isLoggedIn && (
      <div className={`${classes.navbarListIcon} ${className || ""}`}>
        {/* <button
          type="button"
          className={classes.quickAction}
          onClick={onWatchlistClick}
        >
          Watchlist
        </button> */}
        <button type="button" className={classes.alertButton}>
          Alerts
          <span />
        </button>
        <button
          type="button"
          className={classes.profileButton}
          onClick={setIsListModalVisableHandler}
          aria-expanded={isListModalVisable}
        >
          <span className={classes.avatar}>{getInitials(profile.name)}</span>
          <span className={classes.profileText}>
            <strong>{profile.name || "Account"}</strong>
            <small>{profile.userId || "Dashboard"}</small>
          </span>
        </button>

        {isListModalVisable && (
          <>
            <div className={classes.smallListModal}>
              <div className={classes.menuHeader}>
                <span className={classes.avatar}>{getInitials(profile.name)}</span>
                <div>
                  <strong>{profile.name || "Account"}</strong>
                  <small>{profile.email || profile.contact || "Sovereign Auction"}</small>
                </div>
              </div>
              <ul>
                {NavbarSmallLinks.map((link, index) => (
                  <NavbarItem
                    key={link.key ? link.key : link.to + index}
                    pageLink={link.to}
                    onClick={closeMenu}
                  >
                    {link.title}
                  </NavbarItem>
                ))}
                <li onClick={transactionHandle}>Transactions</li>
                <li onClick={winsHandle}>My Wins</li>
                <li onClick={depositHandle}>Security Deposit</li>
                <li className={classes.signout} onClick={onClickSignoutHandler}>
                  Sign out
                </li>
              </ul>
            </div>
            <Backdrop onClose={closeMenu} transparent />
          </>
        )}
      </div>
    )
  );
};

export default NavbarListIcon;
